export default __webpack_public_path__ + "static/media/tax_payer_card.09f68054.jpg";